<template>
  <div class="carousel-slide">
    <picture>
      <!-- preferred webp images -->
      <source :srcset="rootFolder + bigImageFile + '.webp'" 
              type="image/webp"
              class="carousel-slide__image"
              media="(min-width: 1399px) and (min-height: 695px)"
              height="450"
              width="450"/>
      <source :srcset="rootFolder + smallImageFile + '.webp'"
              type="image/webp"
              class="carousel-slide__image"
              height="350"
              width="350"/>
      <!-- fallback jpg images --> 
      <source :srcset="rootFolder + bigImageFile + '.jpg'" 
              type="image/jpg" 
              class="carousel-slide__image"
              media="(min-width: 1399px) and (min-height: 695px)"
              height="450"
              width="450"/>
      <img :src="rootFolder + smallImageFile + '.jpg'" 
            type="image/jpg" 
            class="carousel-slide__image"
            height="350"
            width="350"/>
    </picture>
    <div class="carousel-slide__text">
      <h1>{{ header }}</h1>
      <h2>{{ subheader }}</h2>
      <p v-html="body"/>
    </div>
  </div>
</template>

<script setup lang="ts">
export interface Props {
  header: string,
  subheader: string,
  body: string,
  smallImageFile: string,
  bigImageFile: string
}

const props = defineProps<Props>()

const rootFolder = 'https://static.serato.com/visualizer/images/export_screen_assets/'

</script>

<style lang="scss">
.carousel-slide {
  &__image {
    float: left;
  }

  &__text {
    float: right;
    width: 470px;
    height: 350px;
    margin-left: 80px;
    color: $white;
    font-family: $font-regular;
  }

  h1 {
    margin-top: 8px;
    font-size: 14px;
    letter-spacing: 2px;
    text-transform: uppercase;
    line-height: 17px;
  }

  h2 {
    margin-top: 20px;
    font-size: 44px;
    line-height: 54px;
  }

  p {
    margin-top: 20px;
    font-size: 16px;
    margin-bottom: 20px;
    line-height: 26px;
    padding-right: 70px;

    a {
      color: $link-blue;
      text-decoration-color: transparent;
    }
  }
}
</style>
